import { defineStore } from 'pinia'
import { getTrainerDataRequest, getStudentBalanceDataRequest, getTrainerGroupsRequest, getAssistantGroupsRequest, getPlanedTrainingsByGroupId, getStudentsByGroupIdRequest, getStudentVirtualBalanceRequest, addVirtualIncomeRequest, addRealIncomeRequest, getRealIncomesByBalanceIdRequest } from '../services/apiRequests'

export const useMainStore = defineStore('main', {
    state: () => ({
        trainer: {},
        service_balance: 0,
        student_balance: 0,
        trainer_groups: [],
        allTrainings: [],
        allTrainerIncomes: [],

        currentTrainingStudentsList: [],
        currentTraining: {},

        currentGroup: {},
        allStudentsInGroup: [],
        currentStudent: {},

        currentCompletedTraining: {}
    }),
    
    getters: {
        allPlanedTrainings: (state) => state.allTrainings.filter(training => training.status === 'planed'),
        trainer_id: (state) => state.trainer.trainer_id,
        trainer_position: (state) => state.trainer.position,
        group_name: (state) => state.trainer_groups

    },
    
    actions: {
        async getTrainerData() {
            const res = await getTrainerDataRequest()
            console.log('res.data', res.status)
            this.trainer = res.data
            return res
        },

        async getStudentsInGroupForView() {
            const res = await getStudentsByGroupIdRequest(this.currentGroup.group_id)
            this.allStudentsInGroup = res.data
        },

        async getStudentBalanceData() {
            const res = await getStudentBalanceDataRequest(this.trainer?.student_balance_id)
            this.student_balance = res.data.balance_state
        },

        async getServiceBalanceData() {
            const res = await getStudentBalanceDataRequest(this.trainer.service_balance_id)
            this.service_balance = res.data.balance_state
        },

        async getTrainerGroups() {
            const res = await getTrainerGroupsRequest(this.trainer.trainer_id)
            console.log('res.data', res.data)
            const assistantsRes = await getAssistantGroupsRequest(this.trainer.trainer_id)
            console.log('assistantsRes.data', assistantsRes.data)
            if (assistantsRes?.data?.length > 0) {
                this.trainer_groups = [...res.data, ...assistantsRes.data]
            }
            else {
                this.trainer_groups = res.data
            }
        },

        async getAllTrainerPlanedTrainings() {

            this.allTrainings = []
            let allPlanedTrainings = []

            for (let i = 0; i < this.trainer_groups.length; i++) {
                const res = await getPlanedTrainingsByGroupId(this.trainer_groups[i].group_id)
                console.log('res.data --------- ', res.data)
                allPlanedTrainings.push(...res.data)
            }

            this.allTrainings.push(...allPlanedTrainings)
            this.allTrainings.sort((a, b) => {
                return new Date(a.date) - new Date(b.date)
            })

        },

        async getAllStudentByGroupId(groupId) {
            const res = await getStudentsByGroupIdRequest(groupId)
            this.currentTrainingStudentsList = res.data
        },

        async getAllStudentsByTrainerGroups() {
            const result = []
            for (let i = 0; i < this.trainer_groups.length; i++) {
                const res = await getStudentsByGroupIdRequest(this.trainer_groups[i].group_id)
                result.push(...res.data)
            }
            return result
        },
        
        async getVirtualStudentBalance(balance_id) {
            const res = await getStudentVirtualBalanceRequest(balance_id)
            return res.data.balance_state
        },

        async proccessIncomeTransaction(trainerStudentBalanceId, studentVirtualBalanceId, amount, trainerName, studentName) {
            const studentVirtualIncomeLabel = `Поповнення балансу через тренера ${trainerName}`
            const virtualIncomeResponse = await addVirtualIncomeRequest(studentVirtualBalanceId, amount, studentVirtualIncomeLabel)

            const virtualTxId = virtualIncomeResponse.data.tx_id
            const trainerStudentIncomeLabel = `Поповнення балансу від студента ${studentName}`
            const trainerStudentIncomeResponse = await addRealIncomeRequest(trainerStudentBalanceId, amount, trainerStudentIncomeLabel, virtualTxId)

            return true
        },

        async getTrainerRealIncomes() {
            const res = await getRealIncomesByBalanceIdRequest(this.trainer.student_balance_id)
            this.allTrainerIncomes = res.data.real_incomes.reverse()
        }
    }
})